"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORAGE_KEY = void 0;
const STORAGE_KEY = exports.STORAGE_KEY = 'auth-widget/remembered_accounts';